export default class HolidayAllowanceViewModel {
    public adjustedEntitlement: number = 0;
    public currentEntitlement: number = 0;
    public holidayEndDate: number = 0;
    public holidayRemianingInDays: number = 0;
}